import { TOP_ADVISORS_BY_CITY } from '@ria-client/advisor-search/constants';
import { Link } from '@ria-client/tw-shared-ui/layout/link';
import { Section } from '@ria-client/tw-shared-ui/layout/section';

import { CardCtaLink } from './CardCtaLink';
import { LinkCard } from './LinkCard';
import { LinkCardGrid } from './LinkCardGrid';
import { SectionHeader } from './SectionHeader';
import { LocationIcon } from './icons';

export function TopAdvisorsByCity() {
  return (
    <Section aria-label="Financial advisors by city">
      <SectionHeader
        icon={<LocationIcon className="size-4.5" />}
        title="Financial advisors by city"
      />
      <p className="typography-text-small -mt-6 mb-8 text-muted-foreground">
        See our picks for financial advisors by city or state, based on our editorial methodology
        that considers total assets under management, types of clients serviced, client-to-advisor
        ratios and other factors.{' '}
        <Link
          className="font-semibold text-primary no-underline"
          href="https://www.nerdwallet.com/l/ratings-methodology-for-financial-advisors-by-city"
        >
          (View the full methodology here)
        </Link>
      </p>
      <LinkCardGrid>
        {TOP_ADVISORS_BY_CITY.map(city => (
          <LinkCard key={city.city} href={city.url} layout="row">
            <span className="advisor-search-city-emoji shrink-0">{city.emoji}</span>
            <span>
              <h4 className="typography-text-bold mb-1">Financial Advisors in {city.city}</h4>
              <CardCtaLink label="View our picks" />
            </span>
          </LinkCard>
        ))}
      </LinkCardGrid>
    </Section>
  );
}
